import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { isAdminRole } from "@/lib/roles";
import { AppShell } from "@/components/AppShell";
import Login from "@/pages/Login";
import QuickReply from "@/pages/QuickReply";
import Categories from "@/pages/Categories";
import Users from "@/pages/Users";
import PassportCheck from "@/pages/PassportCheck";
import AuditLog from "@/pages/AuditLog";
import Landing from "@/pages/Landing";
import Bookings from "@/pages/Bookings";
import NotificationSettings from "@/pages/NotifySettingsAdmin";
import SeatStatus from "@/pages/SeatStatus";

const Protected = ({ admin, superadmin, children }) => {
  const { user } = useAuth();
  if (user === null) {
    return <div className="flex min-h-screen items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-brand" /></div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (admin && !isAdminRole(user.role)) return <Navigate to="/balasan" replace />;
  if (superadmin && user.role !== "superadmin") return <Navigate to="/balasan" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route element={<Protected><AppShell /></Protected>}>
            <Route path="/balasan" element={<QuickReply />} />
            <Route path="/cek-paspor" element={<PassportCheck />} />
            <Route path="/booking" element={<Bookings />} />
            <Route path="/status-seat" element={<SeatStatus />} />
            <Route path="/notifikasi" element={<Protected superadmin><NotificationSettings /></Protected>} />
            <Route path="/kategori" element={<Protected admin><Categories /></Protected>} />
            <Route path="/pengguna" element={<Protected admin><Users /></Protected>} />
            <Route path="/riwayat" element={<Protected admin><AuditLog /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </AuthProvider>
  );
}

export default App;
